import { render, staticRenderFns } from "./Netdetail.vue?vue&type=template&id=12df94aa&scoped=true"
import script from "./Netdetail.vue?vue&type=script&lang=js"
export * from "./Netdetail.vue?vue&type=script&lang=js"
import style0 from "./Netdetail.vue?vue&type=style&index=0&id=12df94aa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12df94aa",
  null
  
)

export default component.exports